<div class="row">
  <div class="col-lg-2">
    <div>
      <img *ngIf="shape === 'circle'" [src]="displayValue" alt="" class="rounded-circle avatar-sm"
        (error)="showDefault($event)" />
      <img *ngIf="shape === 'square'" [src]=" displayValue" alt="" [ngClass]="size" (error)="showDefault($event)" />
    </div>
  </div>
</div>